import React, {
  useEffect,
  useRef
} from "react";
import JsBarcode from "jsbarcode";

export type BarcodeFormatType = "CODE128" | "EAN13";

export interface BarcodeProps {
  value: string;
  format?: BarcodeFormatType;
  width?: number;
  height?: number;
}

/**
 * A Barcode component that acts as proxy access to use of JsBarcode package
 *
 * @returns an image of the barcode based on a value given
 */
const Barcode: React.ReactFCWithChildren<BarcodeProps> = ({
  value,
  format = "CODE128",
  width = 2,
  height = 100
}) => {
  const renderElement = useRef<HTMLImageElement>(null);

  // when barcode value changes, update image
  useEffect(() => {
    if (value) {
      try {
        JsBarcode(renderElement.current, value, {
          format,
          width,
          height
        });
      } catch (error) {
        console.error(error);
      }
    }
  }, [ value ]);

  return (
    <img
      style={{
        maxWidth: "100%",
        padding: "8px",
        maxHeight: "110px",
        background: "white",
        borderRadius: "4px"
      }}
      ref={renderElement}
      alt={`barcode: ${value}`}
    />
  );
};

export default Barcode;
